import moment from 'moment';
import { CustomerDetailsModel } from './CustomerDetailsModel';
import { AppRebatesModel } from './AppRebatesModel';
import { UserModel } from './UserModel';
import { VoucherModel } from './VoucherModel';
import { StoreReceiptModel } from './StoreReceiptModel';
export class RebatesByStatusModel {
    constructor(payload) {
        Object.assign(this, payload);
        this.app = new AppRebatesModel(payload.app);
        const { customerDetail, updater } = payload;
        const storeReceipts = payload.storeReceipts.edges;
        if (customerDetail) {
            this.customerDetail = new CustomerDetailsModel(customerDetail);
        }
        if (updater) {
            this.updater = new UserModel(updater);
        }
        if (payload.vouchers) {
            const vouchers = payload.vouchers.edges;
            this.vouchers = vouchers.map((voucher) => {
                return new VoucherModel(voucher.node);
            });
        }
        if (storeReceipts) {
            this.storeReceipts = storeReceipts.map((storeReceipt) => {
                return new StoreReceiptModel(storeReceipt.node);
            });
        }
    }
    get formattedCreatedAt() {
        const placedAt = new Date(this.createdAt);
        return moment(placedAt).format('LLL');
    }
    get formattedApprovedAt() {
        if (this.approvedAt) {
            const approvedAt = new Date(this.approvedAt);
            return moment(approvedAt).format('LLL');
        }
        return '';
    }
    get formattedRejectedAt() {
        if (this.rejectedAt) {
            const rejectedAt = new Date(this.rejectedAt);
            return moment(rejectedAt).format('LLL');
        }
        return '';
    }
    get verifiedBy() {
        if (this.updater) {
            return this.updater.fullName;
        }
        return '';
    }
}
